import React from "react";
import { array, elementType, shape, string } from "prop-types";
import Template from "@insightfulscience/contentful/Apps/components/Template/index.js";
import { mapItems } from "@insightfulscience/contentful/Apps/components/FeaturedContentBlock/mapper.js";
import FeaturedContentItems from "./FeaturedContentItems";

const BlockFeaturedContent = ({
	id,
	name,
	subname,
	contentReference = [],
	components,
	...props
}) => {
	const SectionTemplate = components?.sectionTemplate || Template;

	return (
		<SectionTemplate title={name} subtitle={subname} anchor={id}>
			<FeaturedContentItems withFilter items={mapItems(contentReference)} {...props} isImgFluid />
		</SectionTemplate>
	);
};

BlockFeaturedContent.propTypes = {
	id: string.isRequired,
	name: string.isRequired,
	subname: string,
	contentReference: array, // eslint-disable-line react/forbid-prop-types
	imgClassName: string,
	components: shape({
		sectionTemplate: elementType,
	}),
};

export default BlockFeaturedContent;
